export enum UserPoolsEnum {
  Admin = 'admin',
  Retail = 'retail',
}
